export default __webpack_public_path__ + "static/arindamLehri16-06b8bbc2df6ddab46ca12c355482c76e.jpg";